import { render } from "./App.vue?vue&type=template&id=8dd6f8e0"
const script = {}

import exportComponent from "../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__